import { render, staticRenderFns } from "./tosatInfo.vue?vue&type=template&id=290ccf35&scoped=true&"
import script from "./tosatInfo.vue?vue&type=script&lang=js&"
export * from "./tosatInfo.vue?vue&type=script&lang=js&"
import style0 from "./tosatInfo.vue?vue&type=style&index=0&id=290ccf35&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290ccf35",
  null
  
)

export default component.exports